import React from 'react'
import DynamicBreadcrumb from '../../../components/DynamicBreadcrumb'
import TechnologyHead from '../techComponent/TechnologyHead'
import TechnologyNex from '../techComponent/TechnologyNex';

const breadcrumbData = [
  {
    page: "Home",
    slug: "/",
  },
  {
    page: "Technologies",
    slug: "",
  },
  {
    page: "Infrastructure & Cybersecurity",
    slug: "",
  }
]

const techData = {
  label: "Technologies",
  heading: "Infrastructure & Cybersecurity",
  img: "/assets/images/infra-cyber.webp",
  alt: "Infrastructure & Cybersecurity",
  description: `
    <p>Every coin has two sides and similar is the case with technology. With the continuous advancement in technology, demerits tag along with the benefits and increased the damage of risks multifold. Keeping this thought in mind, we at Dox and Box came up with advanced technologies and systems to keep building on our infrastructure and simultaneously keep cyber threats at bay. Our Internet security team has professionals and experts always on the lookout for new and ongoing cyber threats to find ways of countering them and protect the valuable data and records of our clients.</p>

    <p>We have a highly developed infrastructure that ensures proper counterattack against cyber threats through identification and improvisation of the existing systems. Cybersecurity is one of the growing concerns in today's time to prevent information loss and sabotage by cyber attacks. You need to be fully aware of the threats and risks of cyberattacks and how they can be combated before you begin to develop any systems or technology. Few protocols in place for us at Dox and Box are:</p>

    <h2>Smart Solutions</h2>
    <p>Smart Solutions for document management by Dox and Box combine robust infrastructure and advanced cybersecurity to ensure secure, scalable, uninterrupted data handling. Built on resilient systems, it protects critical records with encryption, access controls, continuous monitoring across all touchpoints. With compliance-driven architecture and proactive threat protection, it delivers a secure, efficient, future-ready document management ecosystem.</p>

    <ul>
      <li>Adequate and proper training of staff to completely understand the risks involved with cyberattacks.</li>

      <li>Complete training of the staff on combat methods for records and data protection, such as malware detection software, malicious application removal, anti-key logger technology, etc.</li>

      <li>Multi Scanning of records and data to avoid the unrequited transfer of data and eliminate sabotage.</li>

    </ul>

    <p>Instant access, complete visibility, proper management of information and data play a huge role in the timely identification of any data breach. Proper infrastructure and advanced cybersecurity technologies also play a critical role in combating sabotage attempts through cyberattacks. Quick access to records and data enables better management and helps maintain up-to-date cybersecurity measures. Dox and Box has implemented advanced technologies such as IoT-enabled systems to protect and secure your data. Deploying multiple layers of defense ultimately strengthens your ability to protect your infrastructure from malicious activities.</p>

  `
};

const techNextData = [
  {
    img: "assets/images/ai-cyber.webp",
    title: "Artificial Intelligence",
    slug: "/artificial-intelligence"
  },
  {
    img: "/assets/images/data-integration.webp",
    title: "Data integration & visibility",
    slug: "/data-integration-visibility"
  },
];

export default function InfraCyber() {
  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <TechnologyHead data={techData} />
      <TechnologyNex technex={techNextData} />
    </>
  )
}
